module.exports = __webpack_public_path__ + "static/media/ZIP.60679b77.svg";